import { createContext, useContext, useEffect, useState } from "react";
import { isLoggedIn } from "~/utils/auth";
import { AuthService } from "~/services/authService";

const defaultUser = {
  isLoggedIn: isLoggedIn(),
  username: "",
  first_name: "",
  last_name: "",
  role: 0,
  role_name: "",
  role_rights: [],
};

const UserContext = createContext(defaultUser);

export const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState(defaultUser);

// Création du service API et appel du hook utilisé pour le profile
  const authService = new AuthService();
  const {
    data: apiGetData,
    error: apiGetError,
    isLoading: apiGetIsLoading,
    callToAction: apiGetHandler,
  } = authService.useMe();

  useEffect(() => {
    if (apiGetData) {
      setUser(apiGetData);
    }
  }, [apiGetData]);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => {
  const { user, setUser } = useContext(UserContext);
  return { user, setUser };
};
